import axios from 'axios';
import authHeader from './auth-header';
import http from './http-common';

import { API_URLU }  from '../config/constant'

const getUserById = (id) => {
  return axios.get(API_URLU + 'user/' + id, { headers: authHeader() });
};

const getUsers = () => {
  return axios.get(API_URLU + 'user', { headers: authHeader() });
};

const postUser = (data) => {
  return axios.post(API_URLU + 'user/', data, { headers: authHeader() });
};

const getByUsername = (username) => {
  return axios.get(API_URLU + 'userName/' + username, { headers: authHeader() });
};

const updatePass = (data) => {
  return axios.patch(API_URLU + 'changepwd', data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU + 'update-user-profile?id=' + data.id + '&longName=' + data.longName + '&email=' + data.email + '&phone=' + data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(API_URLU + 'update-user-image?id=' + data.id + '&photoUrl=' + data.photoUrl, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + 'company/' + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + 'company', { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + 'company/', data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + 'system/' + id, { headers: authHeader() });
};

const getSystems = () => {
  return axios.get(API_URLU + 'system', { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + 'system/', data, { headers: authHeader() });
};

const postUserComp = (data) => {
  return axios.post(API_URLU + 'ucompany/', data, { headers: authHeader() });
};

// const getUserCompbk = (data) => {
//   return axios.get(API_URLU + 'ucompany/', data, { headers: authHeader() });
// };
// const getUserComp = () => {
//   return axios.get(API_URLU + 'user-companies', { headers: authHeader() });
// };

const getUserComp = (id) => {
  return axios.get(API_URLU + 'user-companies?userId=' + id, { headers: authHeader() });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + 'user-systems/', data, { headers: authHeader() });
};

const getCompSystems = () => {
  return axios.get(API_URLU + 'company-systems', { headers: authHeader() });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + 'user-company-systems', { headers: authHeader() });
};

const getUserCompUSystems = () => {
  return axios.get(API_URLU + 'user-company-usystems', { headers: authHeader() });
};

const getCmsGeneralCodes = (id) => {
  return axios.get(API_URLU + 'cms-general-codes?codeType=' + id, { headers: authHeader() });
};

const getCustomerById = (id) => {
  return axios.get(API_URLU + 'customer/' + id, { headers: authHeader() });
};

const getCmpCustomers = (id) => {
  return axios.get(API_URLU + 'cmp_customer/' + id, { headers: authHeader() });
};

const getCustomers = () => {
  return axios.get(API_URLU + 'customer', { headers: authHeader() });
};

const postCustomer = (data) => {
  return axios.post(API_URLU + 'customer', data, { headers: authHeader() });
};

const putCustomer = (data) => {
  return axios.put(API_URLU + 'customer/' + data.custId, data, { headers: authHeader() });
};

const getEmployeeById = (id) => {
  return axios.get(API_URLU + 'chr_employee/' + id, { headers: authHeader() });
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + 'chr_by_username/' + name, { headers: authHeader() });
};

const getEmployees = () => {
  return axios.get(API_URLU + 'chr_employee', { headers: authHeader() });
};

const getPagedEmployees = (offset, pageSize) => {
  return axios.get(API_URLU + 'employee/' + offset + '/' + pageSize, { headers: authHeader() });
};

const postEmployee = (data) => {
  return axios.post(API_URLU + 'employee/', data, { headers: authHeader() });
};

const putEmployee = (id, data) => {
  return axios.put(API_URLU + 'employee/' + id, data, { headers: authHeader() });
};

const getClassification = () => {
  return axios.get(API_URLU + 'classification', { headers: authHeader() });
};

const getGeneral = () => {
  return axios.get(API_URLU + 'general', { headers: authHeader() });
};

const postTempBranch = (data) => {
  return axios.post(API_URLU + 'branch/', data, { headers: authHeader() });
};

const getTempBranch = () => {
  return axios.get(API_URLU + 'branch', { headers: authHeader() });
};

const saveInvoice = (invoice) => {
  return axios.post(API_URLU + 'SaveInvoice/', invoice, { headers: authHeader() });
};

const getInvoiceInfo = () => {
  return axios.get(API_URLU + 'getInfo', { headers: authHeader() });
};

const getScheduledLeaves = () => {
  return axios.get(API_URLU + 'scheduled_leaves', { headers: authHeader() });
};

const postLeaveSchedule = (data) => {
  return axios.post(API_URLU + 'scheduled_leaves/', data, { headers: authHeader() });
};

const getLeaveAccruals = () => {
  return axios.get(API_URLU + 'leave_accruals/', { headers: authHeader() });
};

const getLeaveApplications = () => {
  return axios.get(API_URLU + 'leave_applications', { headers: authHeader() });
};

const postLeaveApplication = (data) => {
  return axios.post(API_URLU + 'leave_applications/', data, { headers: authHeader() });
};

const getLeaveTransactions = () => {
  return axios.get(API_URLU + 'leave_transactions', { headers: authHeader() });
};

const getLeaveRejections = () => {
  return axios.get(API_URLU + 'leave_rejections', { headers: authHeader() });
};

const getLeaveTypes = () => {
  return axios.get(API_URLU + 'leave_types', { headers: authHeader() });
};

const getProductCodes = () => {
  return axios.get(API_URLU + 'ipen_product_codes', { headers: authHeader() });
};

const getReturnDate = (data) => {
  return axios.get(
    API_URLU +
      'return_date?startDate=' +
      data.startDate +
      '&appliedDays=' +
      data.appliedDays +
      '&leaveCode=' +
      data.leaveCode +
      '&cmpId=' +
      data.cmpId,
    { headers: authHeader() }
  );
};

const getCompanySchemes = (id) => {
  return axios.get(API_URLU + 'schemes/' + id, { headers: authHeader() });
};

const getVwCompanySchemes = (data) => {
  return axios.get(API_URLU + 'vw-ipn-policies?cmpId=' + data.id + '&plcId=' + data.plcId, { headers: authHeader() });
};

const getCompanySchemesByPlcId = (id) => {
  return axios.get(API_URLU + 'schemesbyplc/' + id, { headers: authHeader() });
};

const getSchemeMembers = (id) => {
  return axios.get(API_URLU + 'members/' + id, { headers: authHeader() });
};

const getSchemes = () => {
  return axios.get(API_URLU + 'schemes', { headers: authHeader() });
};

const getMemberReports = () => {
  return axios.get(API_URLU + 'ipn-emp-reports', { headers: authHeader() });
};

const postScheme = (data) => {
  return axios.post(API_URLU + 'schemes', data, { headers: authHeader() });
};

const postMember = (data) => {
  return axios.post(API_URLU + 'members', data, { headers: authHeader() });
};

const getIpnProducts = (id) => {
  return axios.get(API_URLU + 'ipn-company-products?cmpId=' + id, { headers: authHeader() });
};

const getCompanyCurrencies = (id) => {
  return axios.get(API_URLU + 'company-currencies?cmpId=' + id, { headers: authHeader() });
};

const getCmsCodeDesc = (data, codeType) => {
  return axios.get(API_URLU + 'get_cms_code_description?cmpId=' + data.cmpId + '&codeId=' + data.custCode + '&codeType=' + codeType, {
    headers: authHeader()
  });
};

const getCmsCodeDesc2 = (cmpId, codeId, codeType) => {
  return axios.get(API_URLU + 'get_cms_code_description?cmpId=' + cmpId + '&codeId=' + codeId + '&codeType=' + codeType, {
    headers: authHeader()
  });
};

const genSchemeNo = (data) => {
  // return axios.get(API_URLU + 'get-scheme-no?cmpId='+ id, { headers: authHeader() });
  return axios.get(API_URLU + 'getdocnumber?cmpId=' + data.cmpId + '&transType=' + data.transType + '&transDate=' + data.transDate, {
    headers: authHeader()
  });
};

const getIpnGeneralCodes = (id) => {
  return axios.get(API_URLU + 'ipn-general-codes?codeType=' + id, { headers: authHeader() });
};

const getUploadRefNo = () => {
  return axios.get(API_URLU + 'get-upload-refNo', { headers: authHeader() });
};

const uploadcsvDoc = (data) => {
  let formData = new FormData();
  formData.append('file', data.file);
  return http.post('/uploadcsv?uploadRefNo=' + data.id, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const uploadFile = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/singleUpload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/upload_chr_employees', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const getFiles = () => {
  return http.get('/files');
};

const ValidateMemberUpload = (data) => {
  return axios.get(
    API_URLU +
      'validate-member-upload?uploadRefNo=' +
      data.uploadRefNo +
      '&plcId=' +
      data.plcId +
      '&cmpId=' +
      data.cmpId,
    {
      headers: authHeader()
    }
  );
};

const InsertMemberUpload = (data) => {
  return axios.get(
    API_URLU +
      'insert-member-upload?uploadRefNo=' +
      data.uploadRefNo +
      '&plcId=' +
      data.plcId +
      '&cmpId=' +
      data.cmpId +
      '&username=' +
      data.username,
    {
      headers: authHeader()
    }
  );
};

const getUploadMemDetails = (id) => {
  return axios.get(API_URLU + 'vw-upload-details?uploadRefNo=' + id, { headers: authHeader() });
};

const getUploadMemRejects = (id) => {
  return axios.get(API_URLU + 'vw-upload-rejects?uploadRefNo=' + id, { headers: authHeader() });
};

const getUploadMemValid = (id) => {
  return axios.get(API_URLU + 'vw-upload-valid?uploadRefNo=' + id, { headers: authHeader() });
};

const postMemberUpload = (data) => {
  return axios.post(API_URLU + 'members', data, { headers: authHeader() });
};

const deleteMemUploadById = (id) => {
  return axios.delete(API_URLU + 'upload-details/' + id, { headers: authHeader() });
};

const deleteMemUploadReject = (id) => {
  return axios.delete(API_URLU + 'delete-reject?sequenceNo=' + id, { headers: authHeader() });
};

const getPolCompanies = (id) => {
  return axios.get(API_URLU + 'pol-company-byplc/' + id, { headers: authHeader() });
};

const getRelatedpolicies = (id) => {
  return axios.get(API_URLU + 'related-pol-byplc/' + id, { headers: authHeader() });
};

const getVestScaleHeaders = (id) => {
  return axios.get(API_URLU + 'vest-scale-header-byplc/' + id, { headers: authHeader() });
};

const getVestScales = (id) => {
  return axios.get(API_URLU + 'vest-scale-byphv/' + id, { headers: authHeader() });
};

const getTrusteeHeadByPlc = (id) => {
  return axios.get(API_URLU + 'pol-trustee-head-byplc/' + id, { headers: authHeader() });
};

const getTrusteeByThdId = (id) => {
  return axios.get(API_URLU + 'pol-trustee-bythdId/' + id, { headers: authHeader() });
};

const getEndorsementsByPlc= (id) => {
  return axios.get(API_URLU + 'pol-endorse-byplc/' + id, { headers: authHeader() });
};

const getPolAttachSumsByPlc= (id) => {
  return axios.get(API_URLU + 'pol-attach-sum-byplc/' + id, { headers: authHeader() });
};

const getPolAttachmentsByPlc= (data) => {
  return axios.get(API_URLU + 'pol-attach-byplc/' + data.id + "/" + data.docType, { headers: authHeader() });
};

const getCustomerByCmpId = (data) => {
  return axios.get(API_URLU + 'cmp_customer/' + data.id + '/' + data.offset + '/' + data.pageSize, { headers: authHeader() });
};

const getPolNo = (data) => {
  return axios.get(
    API_URLU +
      'getPolnumber?cmpId=' +
      data.cmpId +
      '&transType=' +
      data.transType +
      '&branchCode=' +
      data.branchCode +
      '&transDate=' +
      data.transDate,
    { headers: authHeader() }
  );
};

const getCustomerByCode = (data) => {
  return axios.get(API_URLU + 'customerCode?cmpId=' + data.cmpId + '&custCode=' + data.custCode, { headers: authHeader() });
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getUserById,
  getUsers,
  postUser,
  getByUsername,
  updatePass,
  updateUserImg,
  updateUser,
  getCompById,
  getCompanies,
  postComp,
  getSystemById,
  getSystems,
  postSystem,
  postUserComp,
  postUserSystems,
  getUserComp,
  getCompSystems,
  getUserCompSystems,
  getUserCompUSystems,
  getCustomerById,
  getCmpCustomers,
  getCustomers,
  postCustomer,
  putCustomer,
  getEmployeeById,
  getEmployeeByUsername,
  getEmployees,
  getPagedEmployees,
  postEmployee,
  putEmployee,
  getClassification,
  getGeneral,
  getFiles,
  saveInvoice,
  getInvoiceInfo,
  getScheduledLeaves,
  postLeaveSchedule,
  getLeaveAccruals,
  getLeaveApplications,
  postLeaveApplication,
  getLeaveTransactions,
  getLeaveRejections,
  getLeaveTypes,
  getProductCodes,
  getReturnDate,
  uploadFile,
  uploadExcel,
  postTempBranch,
  getTempBranch,
  getSchemes,
  postScheme,
  postMember,
  getCompanySchemes,
  getCompanySchemesByPlcId,
  getCompanyCurrencies,
  getSchemeMembers,
  genSchemeNo,
  getIpnProducts,
  getIpnGeneralCodes,
  getCmsGeneralCodes,
  getMemberReports,
  getCmsCodeDesc,
  getCmsCodeDesc2,
  getUploadRefNo,
  uploadcsvDoc,
  InsertMemberUpload,
  getUploadMemDetails,
  getUploadMemRejects,
  getUploadMemValid,
  ValidateMemberUpload,
  postMemberUpload,
  deleteMemUploadById,
  deleteMemUploadReject,
  getVwCompanySchemes,
  getPolCompanies,
  getRelatedpolicies,
  getVestScaleHeaders,
  getVestScales,
  getTrusteeHeadByPlc,
  getTrusteeByThdId,
  getEndorsementsByPlc,
  getPolAttachSumsByPlc,
  getPolAttachmentsByPlc,
  getCustomerByCmpId,
  getPolNo,
  getCustomerByCode
};
